class RunBxslider {
    constructor (){
        let sliders = document.querySelector('[data-selector="slider"]');

        if(sliders){
            $(sliders).bxSlider({
                controls: false,
                pager: true,
                auto: true,
            });
        }
    }
}